import { useSelector } from "react-redux"
import { RootState } from "~/redux/store"

export const useApplicationState = () => {
  const application = useSelector((state: RootState) => state.application)

  return application
}
